import { THEME_CLASSES } from '../constants/main-menu.constants';

const colors = [
  'red',
  'green',
  'orange',
  'blue',
  'pink',
  'purple',
  'yellow',
  'cyan',
  'indigo',
  'teal',
  'bluegray',
  'primary',
];

export const getRandomColorName = (): (typeof colors)[number] => {
  return colors[Math.floor(Math.random() * colors.length)];
};

export const hasAppliedThemeClass = () => {
  return THEME_CLASSES.some(theme => document.body.classList.contains(theme));
};
